<template>
  <!-- @touchmove.prevent -->
  <div
    class="content"
    ref="content"
    :style="{
      ...(step === 1
        ? {
            backgroundImage: `url(${$utils.getPng('icon-short-hbg')})`,
          }
        : {}),
      backgroundColor: bgColor,
    }"
  >
    <Header :title="title" :bgColor="bgColor" @toBack="toBack"></Header>
    <div class="step1" v-if="step == 1">
      <img class="logo" :src="$utils.getPng('icon-short-hlogo')" />
      <div class="checkBox">
        <div
          :class="{
            font: true,
            font2: isType == item.id,
          }"
          v-for="(item, index) in typeList"
          :key="index"
          @click="checkType(item.id)"
        >
          <span>{{ item.name }}</span>
          <div
            :class="{
              line: true,
              lineA: isType == item.id,
            }"
          ></div>
        </div>
      </div>
      <div class="loginBox" v-if="isType == 1">
        <!-- 手机号登录 -->
        <div class="topPhone" v-show="isPhone">
          <div class="codeInputBox">
            <div
              class="pcodeBox"
              v-if="codeList.length > 0"
              @click="showCode = true"
            >
              <span class="font2">{{ pcode }}</span>
              <svg-btn class="icon" icon-class="icon-short-hcode"></svg-btn>
            </div>
            <FmInput
              v-model="phone"
              :class="inputClass"
              placeholder="请输入手机号"
              clearable
            ></FmInput>
          </div>
          <fm-button
            class="loginBt"
            type="primary"
            :disabled="btnTwo"
            round
            size="medium"
            @click="loginclick2"
            >下一步</fm-button
          >
        </div>
        <!-- 其他方式登录 -->
        <div class="top" v-show="!isPhone">
          <FmInput
            style="margin-bottom: 12px"
            v-model="username"
            class="loginInput"
            placeholder="请输入账号/邮箱号/手机号"
            clearable
          ></FmInput>
          <FmInput
            v-model="password"
            class="loginInput"
            placeholder="请输入密码"
            type="password"
            clearable
          ></FmInput>
          <div class="forget"><span @click="toForget">忘记密码</span></div>
          <fm-button
            class="loginBt"
            type="primary"
            round
            size="medium"
            :disabled="btnOne"
            @click="loginclick"
            >登录</fm-button
          >
          <div class="authorization">
            <span class="test1">Fm2 将获得以下权限 </span>
            <span class="test2">· 获取你的Feemoo头像、昵称</span>
            <span class="test2">· 获取你的Feemoo账号</span>
          </div>
        </div>
        <div class="bottom">
          <div class="imgBox">
            <img
              @click="registerQQ"
              :src="$utils.getPng('icon-short-hqq')"
            />
            <img
              v-if="sms_login_switch == 1"
              style="margin-left: 32px"
              @click="checkLogin()"
              :src="
                $utils.getPng(isPhone ? 'icon-short-hps' : 'icon-short-hphone')
              "
            />
          </div>
          <div class="bottomBox" @click="check = !check">
            <svg-btn
              class="check"
              @click.stop="check = !check"
              :icon-class="check ? 'icon-short-hyes' : 'icon-short-hno'"
            />
            <div class="text">
              已详读并同意<span @click.stop="open(91)">《用户服务协议》</span
              >和<span @click.stop="open(86)">《隐私政策》</span>
            </div>
          </div>
        </div>
      </div>
      <div class="registerBox" v-else>
        <div class="topBox">
          <div class="line"></div>
          <span class="font">选择注册方式</span>
          <div class="line"></div>
        </div>
        <div class="bottomBox" @click="toRegister(1)">
          <img class="img" :src="$utils.getPng('icon-short-rphone')" />
          <span class="text">手机号注册</span>
        </div>
        <div class="bottomBox" v-if="email_register_switch == 1" @click="toRegister(2)">
          <img class="img" :src="$utils.getPng('icon-short-remail')" />
          <span class="text">邮箱号注册</span>
        </div>
        <div class="bottomBox" @click="toRegister(3)">
          <img class="img" :src="$utils.getPng('icon-short-rqq')" />
          <span class="text">QQ注册</span>
        </div>
        <div class="authorization">
          <span class="test1">Fm2 将获得以下权限 </span>
          <span class="test2">· 获取你的Feemoo头像、昵称</span>
          <span class="test2">· 获取你的Feemoo账号</span>
        </div>
      </div>
    </div>
    <!-- 设置账号/密码 -->
    <div class="step2" v-if="step == 2">
      <div class="font1">设置账号</div>
      <FmInput
        v-model="username2"
        class="loginInput"
        placeholder="请设置Feemoo账号（6-20位数字或字母）"
        clearable
      ></FmInput>
      <div class="font2">设置密码</div>
      <FmInput
        style="margin-bottom: 12px"
        v-model="password2"
        class="loginInput"
        placeholder="请设置登录密码（至少6位数字或字母）"
        type="password"
        clearable
      ></FmInput>
      <FmInput
        v-model="passwordAgain"
        class="loginInput"
        placeholder="请再次输入密码"
        type="password"
        clearable
      ></FmInput>
      <div class="font2" v-if="zone_switch == 1">选择区服</div>
      <el-select
        class="loginSelect"
        placeholder="请选择区服"
        v-model="zone_id"
        v-if="zone_switch == 1"
      >
        <el-option
          v-for="item in zone_config"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span class="font3" v-if="zone_switch == 1"
        >我们将遵照账号区服当地法律提供服务，一旦确定不可更改</span
      >
      <fm-button
        class="loginBt"
        type="primary"
        :disabled="btnThree"
        round
        size="medium"
        @click="registerQQCheck()"
        >确定</fm-button
      >
    </div>
    <wxLink
      :isShow="wxLinkShow"
      :agreement="true"
      title="提示"
      submitText="同意"
      cancelText="不同意"
      @submit="submitLink"
      @handleClose="closeLink"
    />
    <pcodeCheck
      @touchmove.stop
      :codeList="codeList"
      :show="showCode"
      :code="pcode"
      @close="showCode = false"
      @toCheck="toCheck"
    />
    <SafeDialog @onConfirm="onConfirm" ref="MyDialog" />
    <BrowserRestrict ref="BrowserRestrictRef"></BrowserRestrict>
  </div>
</template>

<script>
import Header from '@/components/NavTopLogin/index.vue'
import wxLink from '@/components/Dialog/wxLink.vue'
import SafeDialog from '@/components/Dialog/SafeDialog.vue'
import BrowserRestrict from '@/components/Dialog/BrowserRestrict'
import pcodeCheck from '@/components/pcodeCheck/index.vue'
import VerificationCode from '@/components/VerificationCode/index.vue'
import {
  loginAPI,
  userLoginVerifyAPI,
  LoginSSOAPI,
  limitationDelAPI,
  getPhonePcodeAPI,
  phoneLoginCodeAPI,
  checkPhone,
  registerAPI,
  checkQQ,
  getZoneIdConfigAPI,
  getEmailRegisterSuffixAPI,
} from '@/axios/login'
export default {
  components: {
    wxLink,
    Header,
    pcodeCheck,
    SafeDialog,
    BrowserRestrict,
    VerificationCode,
  },
  data() {
    return {
      isType: 1,
      username: '',
      password: '',
      selectPsw: '',
      phone: '',
      typeList: [
        {
          id: 1,
          name: '登录',
        },
        {
          id: 2,
          name: '注册',
        },
      ],
      check: false,
      wxLinkShow: false,
      pcode: '+86',
      isPhone: false, //是否手机号登录
      showCode: false,
      fshort: '',
      step: 1, //1是账号密码登录 2是QQ设置账号密码
      title: 'Feemoo',
      bgColor: 'transparent',
      loginTip: {
        pre: '',
        now: '',
        access_token: '',
      },
      codeList: [],
      username2: '',
      password2: '',
      passwordAgain: '',
      isqq: false,
      isWXQQToken: null, //是否是微信QQ扫码注册的拿到的token
      isWXQQType: null, //判断是微信回调还是QQ回调
      token: '',
      zone_id: '', //区服ID
      zone_switch: 0, //区服开关
      zone_config: [], //区服list
      email_register_switch:0,
      sms_login_switch:0,
    }
  },
  watch: {
    deviceClass() {
      if (this.deviceClass == 'pc') {
        window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
      }
    },
  },
  created() {
    //QQ登录
    if (this.$route.query.step) {
      this.step = 2
      this.title = '设置账号/密码'
      if (this.$route.query.t) {
        this.isWXQQToken = this.$route.query.t
      }
      if (this.$route.query.type) {
        this.isWXQQType = this.$route.query.type
      }
      if (this.$route.query.rcode) {
        this.fshort = this.$route.query.rcode
        sessionStorage.setItem('shortFshort', this.fshort)
      }
    }
    //第三方授权登录授权失败,重定向到登录页提示错误信息
    const urlParams = new URLSearchParams(window.location.search)
    let errinfo = urlParams.get('err')
    if (errinfo) {
      let errToast = JSON.parse(errinfo).msg
      this.$htoast(errToast)
    }
    //返回登录页清除多账号信息
    this.$store.commit('setAttr', {
      name: 'accountList',
      val: [],
    })
    //返回登录页清除手机号登录/注册信息
    this.$store.commit('setAttr', {
      name: 'phoneInfo',
      val: {},
    })
  },
  mounted() {
    if (this.deviceClass == 'pc') {
      window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
    }
    // 初始设置
    this.$nextTick(() => {
      this.setRealHeight()
    })
    let shortFshort = sessionStorage.getItem('shortFshort')
    if (shortFshort) {
      this.fshort = sessionStorage.getItem('shortFshort')
    }
    if (this.$route.query.isType) {
      this.isType = this.$route.query.isType
    }
    let limitation = this.$route.query.limitation
    if (limitation) {
      limitation = decodeURIComponent(atob(limitation))
      try {
        let lJson = JSON.parse(limitation)
        if (lJson.type == 1) {
          this.showLimitLogin(lJson)
        } else {
          this.showBrowserRestrict(lJson)
        }
      } catch (e) {}
    }
    this.$router.replace({ query: {} })
    this.getEmailPhoneSwitch()
    this.getZoneIdConfig()
    this.getPhonePcode()
  },
  beforeDestroy() {},
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
    inputClass() {
      if (this.codeList.length > 0) {
        return `codeInput${this.pcode.length - 1}`
      } else {
        return 'loginInput'
      }
    },
    isSafari() {
      const userAgent = navigator.userAgent.toLowerCase()
      const vendor = navigator.vendor ? navigator.vendor.toLowerCase() : ''
      const platform = navigator.platform
        ? navigator.platform.toLowerCase()
        : ''

      // 检测是否为iOS设备
      const isIOS = /iphone|ipad|ipod/.test(platform)

      // 检测是否为Safari
      // 关键改进：结合vendor和platform进行判断
      const isSafari =
        // Safari的vendor是Apple Computer, Inc.
        vendor.includes('apple') &&
        // 用户代理包含safari
        userAgent.includes('safari') &&
        // 排除Chrome和其他浏览器
        !userAgent.includes('chrome') &&
        !userAgent.includes('crios') && // Chrome for iOS
        !userAgent.includes('fxios') // Firefox for iOS

      // 检测是否为浏览器模拟模式
      const isSimulator =
        // 检测到移动设备特征但不是真实移动平台
        (/mobile|iphone|ipad|ipod|android/.test(userAgent) ||
          window.innerWidth < 768) &&
        ![
          'iphone',
          'ipad',
          'ipod',
          'android',
          'linux armv7l',
          'linux aarch64',
        ].includes(platform)

      return {
        isSafari: isSafari && !isSimulator, // 真实Safari且非模拟环境
        isIOS: isIOS,
        isSimulator: isSimulator,
        userAgent: userAgent,
        platform: platform,
      }
    },
    btnOne() {
      if (this.username && this.password.length >= 6) {
        return false
      }
      return true
    },
    btnTwo() {
      if (this.pcode == '+86' && this.phone.length == 11) {
        return false
      } else if (this.pcode != '+86' && this.phone) {
        return false
      }
      return true
    },
    btnThree() {
      if (
        this.username2.trim().length >= 6 &&
        this.password2.trim().length >= 6 &&
        this.passwordAgain.trim().length >= 6
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    //获取可支持的邮箱后缀
    getEmailPhoneSwitch() {
      return new Promise(resolve => {
        getEmailRegisterSuffixAPI()
          .then(res => {
            if(res.status == 1){
              this.email_register_switch = res.data.email_register_switch
              this.sms_login_switch = res.data.sms_login_switch
            }
            resolve(res.data)
          })
          .catch(err => {})
      })
    },
    getZoneIdConfig() {
      getZoneIdConfigAPI()
        .then(res => {
          if (res.status == 1) {
            this.zone_switch = res.data.zone_switch
            this.zone_config = res.data.zone_config
            const selectedZone = this.zone_config.find(
              item => item.is_select == 1
            )
            // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
            this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
          }
        })
        .catch(err => {})
    },
    loginclick: _.debounce(
      function (event) {
        if (event) {
          event.target.blur()
        }
        if (this.btnOne) {
          return
        }
        if (!this.check) {
          this.wxLinkShow = true
          return
        }

        let data = {
          username: this.username,
          password: this.password,
        }
        userLoginVerifyAPI(data)
          .then(res => {
            if (res.status == 1) {
              this.selectUsername = 0
              this.accountList = res.data.list
              this.selectUser = res.data.list?.[this.selectUsername]
              if (res.data.list.length > 1) {
                this.$store.commit('setAttr', {
                  name: 'accountList',
                  val: res.data.list,
                })
                this.$router.push({
                  path: '/account',
                })
              } else {
                this.toLogin()
              }
            } else {
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      },
      200,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    loginFetch(token) {
      LoginSSOAPI({ token }).then(res => {
        if (res.status == 1) {
          localStorage.setItem('shortToken', res.data.authtoken)
          this.toComplete()
        }
      })
    },
    toLogin: _.debounce(
      function (captcha_verify, validate = {}) {
        return new Promise(resolve => {
          if (validate == 'close') {
            return
          }
          let user_id = this.selectUser?.user_id
          let logintp = this.selectUser?.logintp
          let data = {
            lot_number: validate?.lot_number || '',
            captcha_output: validate?.captcha_output || '',
            pass_token: validate?.pass_token || '',
            gen_time: validate?.gen_time || '',
            username: this.username,
            password: this.password,
            logintp: logintp,
            user_id: user_id,
            captcha_verify: captcha_verify || '',
          }
          loginAPI(data)
            .then(res => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.loginFetch(res.data.sso[0]?.token)
                // setTimeout(() => {
                //   this.toComplete()
                // }, 600)
              } else if (res.status == 1011) {
                resolve({
                  result: true,
                  validate: true,
                })
                //在滑块消失后展示弹窗设定600毫秒的延时器
                setTimeout(() => {
                  if (res.data.type == 1) {
                    this.showLimitLogin(res.data)
                  } else {
                    this.showBrowserRestrict(res.data)
                  }
                }, 600)

                return
              } else if (res.status == 4000) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.$htoast(res.msg)
                return
              } else if (res.status == 90001) {
                this.$htoast(res.msg)
                this.$AliCode.handleOpen(this.toLogin)
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  '5b0562a75492b420626b745b229e83a4',
                  this.toLogin
                )
              } else {
                resolve({
                  result: true,
                  validate: false,
                })
                this.$htoast(res.msg)
              }
            })
            .catch(err => {})
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    showBrowserRestrict: _.debounce(
      function (data) {
        this.$refs.BrowserRestrictRef.handleOpen(data)
      },
      50,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    showLimitLogin(data) {
      this.loginTip.pre = data.last_province
      this.loginTip.now = data.current_province
      this.loginTip.access_token = data.access_token
      this.$refs.MyDialog.show(data)
    },
    goNextBrowser(data) {
      //弃用了 现在删除完常用登录地点后 不会自动登录 还需要用户手动点击
      return
      if (data != '') {
        this.loginFetch(data.sso[0]?.token)
      }
      setTimeout(() => {
        this.toComplete()
      }, 600)
    },
    onConfirm: _.debounce(
      function () {
        this.$refs.MyDialog.close()
        limitationDelAPI({
          access_token: this.loginTip.access_token,
        })
          .then(res => {
            if (res.status == 1) {
              this.loginFetch(res.data.sso[0]?.token)
              // setTimeout(() => {
              //   this.toComplete()
              // }, 600)
            } else {
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //获取区号
    getPhonePcode() {
      // type: 1是注册的区号 2是登录 3是忘记密码的区号 4是绑定手机号
      getPhonePcodeAPI({ type: 2 }).then(res => {
        if (res.status == 1) {
          this.codeList = res.data.list
        }
      })
    },
    toRegister(num) {
      if (num == 1) {
        this.$router.push({ path: '/phoneRegister' })
      } else if (num == 2) {
        this.$router.push({ path: '/emailRegister' })
      } else {
        this.registerQQ()
      }
    },
    loginclick2(event) {
      if (event) {
        event.target.blur()
      }
      if (this.btnTwo) {
        return
      }
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.pcode == '+86' && !reg_tel.test(this.phone)) {
        this.$htoast('请正确输入手机号')
        return
      }
      if (!this.check) {
        this.wxLinkShow = true
        return
      }
      this.sendCodeNew()
    },
    sendCodeNew(captcha_verify, validate = {}) {
      return new Promise(resolve => {
        if (validate == 'close') {
          return
        }
        phoneLoginCodeAPI({
          lot_number: validate?.lot_number || '',
          captcha_output: validate?.captcha_output || '',
          pass_token: validate?.pass_token || '',
          gen_time: validate?.gen_time || '',
          pcode: this.pcode,
          phone: this.phone,
          code_type: 0, //验证码类型：0-短信登录注册 1-短信找回密码 2-修改手机号
          captcha_verify: captcha_verify || '',
          sms_type: 0,
        })
          .then(res => {
            if (res.status == 1) {
              resolve({
                result: true,
                validate: true,
              })
              this.$htoast(res.msg)
              this.$store.commit('setAttr', {
                name: 'phoneInfo',
                val: {
                  pcode: this.pcode,
                  phone: this.phone,
                  msgid: res.data.msgid,
                },
              })
              this.$router.push({
                path: '/phone',
              })
            } else if (res.status == 90001) {
              resolve({
                result: false,
                validate: false,
              })
              this.$htoast(res.msg)
              this.$AliCode.handleOpen(this.sendCodeNew)
            } else if (res.status == 90002) {
              this.$utils.initgt4(
                '5b0562a75492b420626b745b229e83a4',
                this.sendCodeNew
              )
            } else {
              resolve({
                result: true,
                validate: true,
              })
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      })
    },
    registerQQCheck: _.debounce(
      function () {
        if (this.btnThree) {
          return
        }
        let zhLength = this.username2.trim().length
        if (zhLength < 6 || zhLength > 20) {
          this.$htoast('Feemoo账号仅支持6-20位数字或字母，请修改')
          return
        }
        if (this.password2 !== this.passwordAgain) {
          this.$htoast('密码不一致，请重试')
          return
        }
        let data = {
          type: this.isWXQQType,
          token: this.isWXQQToken,
          username: this.username2,
          password: this.password2,
          platform: 'h5',
          rcode: this.fshort,
          zone_id: this.zone_id,
        }
        checkQQ(data)
          .then(res => {
            if (res.status == 1) {
              window.location.href = res.data.url
            } else {
              this.$htoast(res.msg)
            }
          })
          .catch(error => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toCheck(num) {
      this.pcode = num
      this.showCode = false
    },
    registerQQ() {
      if (!this.check) {
        this.isqq = true
        this.wxLinkShow = true
        return
      }
      this.isqq = false
      let urls = window.location.origin + this.$route.path
      window.location.href =
        this.$glb.getApiUrl +
        '/user-service/passport/qq' +
        `Login?type=3&platform=h5&rcode=${
          this.fshort
        }&is_pc=1&url=${encodeURIComponent(urls)}`
    },
    checkLogin() {
      this.username = ''
      this.password = ''
      this.phone = ''
      this.pcode = '+86'
      const selectedZone = this.zone_config.find(item => item.is_select == 1)
      // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
      this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
      this.isPhone = !this.isPhone
    },
    toForget() {
      this.$router.push({ path: '/forget' })
    },
    toBack: _.debounce(
      function () {
        if (this.step == 1) {
          if (this.fshort == 'no') {
            this.$router.replace({ path: '/' })
          } else {
            this.$router.replace({ path: '/d/' + this.fshort })
          }
        } else if (this.step == 2) {
          this.title = 'Feemoo'
          this.bgColor = 'transparent'
          this.step = 1
          this.isWXQQToken = null
          this.isWXQQType = null
        }
      },
      50,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toComplete() {
      let fshort = sessionStorage.getItem('shortFshort')
      if (fshort) {
        this.$router.replace({ path: '/d/' + fshort })
      } else {
        this.$router.replace({ path: '/' })
      }
    },
    open(num) {
      // window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      // window.open(url, '_href')
      if (this.detectBrowser()) {
        let url = this.$glb.shareUrl + '/agreement/?code=' + num
        //曲线救国，如果不设置窗口名，浏览器会限制只能开一个窗口
        const windowName = 'login' + new Date().getTime();
        window.open(url, windowName);
      } else {
        window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      }
    },
    closeLink() {
      this.isqq = false
      this.check = false
      this.wxLinkShow = false
    },
    submitLink() {
      this.wxLinkShow = false
      this.check = true
      if (this.isqq) {
        this.registerQQ()
        return
      }
      if (!this.isPhone) {
        this.loginclick()
      } else {
        this.loginclick2()
      }
    },
    //切换方式
    checkType(row) {
      this.email = ''
      this.phone = ''
      this.isType = row
    },
    // 兼容主流浏览器 safari Chrome Firefox
    detectBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      const vendor = navigator.vendor ? navigator.vendor.toLowerCase() : '';
      
      // 检测Safari
      const isSafari =
        vendor.includes('apple') &&
        userAgent.includes('safari') &&
        !userAgent.includes('chrome') &&
        !userAgent.includes('crios') &&
        !userAgent.includes('fxios');
      
      // 检测Chrome（包括移动版Chrome）
      const isChrome =
        (userAgent.includes('chrome') || userAgent.includes('crios')) &&
        // 排除Edge浏览器（因为Edge的UA也可能包含chrome）
        !userAgent.includes('edg') &&
        !userAgent.includes('edge');
      
      // 检测Firefox（包括移动版Firefox）
      const isFirefox = 
        userAgent.includes('firefox') || 
        userAgent.includes('fxios');
      
      // 如果是其中任意一种浏览器则返回true
      return isSafari || isChrome || isFirefox;
    },
    // setRealHeight
    setRealHeight: _.debounce(
      function () {
        if (this.$refs.content) {
          this.$refs.content.style.height = `${window.innerHeight}px`
        }
      },
      200,
      {
        leading: true,
        trailing: false,
      }
    ),
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: auto;
  height: 100vh;
  min-height: 100vh;
  overflow-x: hidden;
  scrollbar-width: none;
  background-size: cover;
  background-position: center 0;
  background-repeat: no-repeat;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  /* Safari特定修复 */
  @supports (-webkit-touch-callout: none) {
    height: -webkit-fill-available;
    min-height: -webkit-fill-available;
  }
  .step1 {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
    margin-top: 50px;
    padding: 0 34px 24px 34px;
    .logo {
      width: 66px;
      height: 66px;
      margin-bottom: 28px;
    }
    .checkBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      flex-shrink: 0;
      .font {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 50px;
        padding: 5px 9px 6px 9px;
        flex-shrink: 0;
        span {
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          white-space: nowrap;
        }
        &:first-child {
          margin-right: 38px;
        }
      }
      .line {
        width: 32px;
        height: 2px;
        margin-top: 3px;
        background: transparent;
        border-radius: 1px 1px 0px 0px;
      }
      .lineA {
        background: #f67942 !important;
      }
      .font2 {
        span {
          color: #f67942 !important;
        }
      }
    }
    .loginBox {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 30px;
      .top {
        margin-bottom: 20px;
        .forget {
          width: 100%;
          margin-top: 16px;
          margin-bottom: 24px;
          text-align: end;
          span {
            font-weight: 400;
            font-size: 14px;
            color: #f67942;
            line-height: 16px;
          }
        }
        .loginBt {
          width: 100%;
          height: 48px;
          border-radius: 48px;
          span {
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
          }
        }
      }
      .topPhone {
        .loginBt {
          width: 100%;
          height: 48px;
          border-radius: 48px;
          margin-top: 24px;
          span {
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
          }
        }
      }
      .bottom {
        display: flex;
        flex-direction: column;
        align-items: center;
        .imgBox {
          display: flex;
          align-items: center;
          margin-bottom: 24px;
          img {
            width: 40px;
            height: 40px;
          }
        }
        .bottomBox {
          display: flex;
          align-items: center;
          .check {
            width: 14px;
            height: 14px;
            margin-right: 6px;
          }
          .text {
            font-weight: 400;
            font-size: 12px;
            color: #bdbdbe;
            line-height: 18px;
            span {
              color: #2c2c2c;
            }
          }
        }
      }
    }
    .registerBox {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      margin-top: 44px;
      .topBox {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 26px;
        min-width: 0;
        .font {
          font-weight: 400;
          font-size: 12px;
          color: #8a8b92;
          line-height: 18px;
          margin: 0 20px;
          white-space: nowrap;
        }
        .line {
          height: 1px;
          min-height: 1px;
          background: #efefef;
          flex: 1;
        }
      }
      .bottomBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 48px;
        border-radius: 24px;
        border: 1px solid #efefef;
        margin-bottom: 12px;
        .img {
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }
        .text {
          font-weight: 400;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 20px;
          min-width: 70px;
          text-align: center;
        }
      }
    }
  }
  .step2 {
    height: 100%;
    padding: 40px 34px 0 34px;
    display: flex;
    flex-direction: column;
    .font1 {
      font-weight: 400;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 20px;
      margin-bottom: 12px;
    }
    .font2 {
      font-weight: 400;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 20px;
      margin-bottom: 12px;
      margin-top: 36px;
    }
    .font3 {
      font-weight: 400;
      font-size: 11px;
      color: #bdbdbe;
      line-height: 16px;
      margin-top: 4px;
      margin-left: 6px;
    }
    .loginBt {
      width: 100%;
      height: 48px;
      border-radius: 48px;
      margin-top: 24px;
      span {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }
  .authorization {
    display: flex;
    flex-direction: column;
    margin-top: 32px;
    .test1 {
      font-weight: 400;
      font-size: 12px;
      color: #2c2c2c;
      line-height: 18px;
      margin-bottom: 6px;
      width: 100%;
      text-align: center;
    }
    .test2 {
      font-weight: 400;
      font-size: 12px;
      color: #bdbdbe;
      line-height: 18px;
    }
  }
}
</style>
